import React from 'react';
import { noop } from 'lodash';
import { bool, func, number, string } from 'prop-types';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import dynamicTranslation from '../../../../utils/translation/DynamicTranslationService';
import './styles.scss';

const getTexts = ({ num, workSampleChecked, industryDropdownSelected, businessChecked, searchTerm }) => {
    const texts = [];

    if (num > 0) {
        texts.push(<I18n k="reviews.filters.clean.stars" params={{ count: num }} />);
    }
    if (industryDropdownSelected) {
        texts.push(
            <>
                {dynamicTranslation.getIndustryTranslation(industryDropdownSelected)}{' '}
                <I18n k="reviews.filters.clean.industry" />
            </>
        );
    }

    if (workSampleChecked) {
        texts.push(<I18n k="reviews.filters.clean.work_sample_delivery_image" />);
    }

    if (businessChecked) {
        texts.push(<I18n k="reviews.filters.clean.pro_client" />);
    }

    if (searchTerm) {
        texts.push(`"${searchTerm?.replaceAll('"', '')}"`);
    }

    return texts;
};

const FilterDetails = ({
    num = 0,
    onClear = noop,
    workSampleChecked = false,
    industryDropdownSelected = null,
    businessChecked = false,
    searchTerm = '',
}) => {
    const texts = getTexts({
        num,
        workSampleChecked,
        industryDropdownSelected,
        businessChecked,
        searchTerm,
    });

    if (texts.length === 0) {
        return null;
    }

    return (
        <div className="clean-filter-details col-12-xs tbody-5">
            <span className="filter-by">
                <I18n k="reviews.filters.clean.filtering_by" params={{ count: num }} />:
            </span>
            {texts.map((entry, index) => (
                <span key={index}>
                    {entry}
                    {index < texts.length - 1 && <>, </>}
                </span>
            ))}
            <Button className="m-l-8" intent="secondary" variant="outline" size="sm" onClick={onClear}>
                <I18n k="reviews.filters.clean.clear_all" />
            </Button>
        </div>
    );
};

FilterDetails.propTypes = {
    num: number,
    workSampleChecked: bool,
    industryDropdownSelected: string,
    businessChecked: bool,
    onClear: func,
};

export default FilterDetails;
